// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"e3e65ed4","977":"0398648a"}[chunkId] + ".chunk.js";
};